"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var selectable_item_view_model_1 = require("./selectable-item-view.model");
var ItemSelectorComponent = (function () {
    function ItemSelectorComponent() {
        this.itemSelected = new core_1.EventEmitter();
    }
    ItemSelectorComponent.prototype.onSelectedItem = function (item) {
        this.selectedItem = item;
        this.itemSelected.emit(item);
    };
    return ItemSelectorComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", selectable_item_view_model_1.SelectableItemViewModel)
], ItemSelectorComponent.prototype, "selectedItem", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], ItemSelectorComponent.prototype, "items", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], ItemSelectorComponent.prototype, "itemType", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], ItemSelectorComponent.prototype, "itemSelected", void 0);
ItemSelectorComponent = __decorate([
    core_1.Component({
        selector: 'item-selector',
        template: "<div class=\"btn-group policyBox\" ngbDropdown>     <button class=\"btn btn-primary dropdown-toggle\" id=\"dropdownMenu\" ngbDropdownToggle>         <ng-container *ngIf=\"selectedItem\">             <span [innerHTML]=\"selectedItem.preview\"></span>             <span class=\"caret\"></span>         </ng-container>         <ng-container *ngIf=\"!selectedItem && items?.length > 0\"><b>Select a {{itemType}}</b>&nbsp;<span class=\"caret\"></span></ng-container>         <ng-container *ngIf=\"!selectedItem && !items?.length\"><i class=\"fa fa-spinner fa-spin fa-pulse\"></i> Loading...</ng-container>     </button>     <ul class=\"dropdown-menu\" role=\"menu\" aria-labelledby=\"dropdownMenu\">         <li *ngFor=\"let item of items\" class=\"dropdown-item\" [class.active]=\"item === selectectItem\">             <a href=\"javascript:void(0)\" (click)=\"onSelectedItem(item)\">                 <div [innerHTML]=\"item.title\"></div>                 <div [innerHTML]=\"item.subTitle\"></div>                 <div *ngIf=\"item.supplementalInformation\" [innerHTML]=\"item.supplementalInformation\"></div>             </a>         </li>     </ul> </div>",
        styles: ["\n        .show > .dropdown-menu {\n            display: block;\n        }\n\n        .policyBox .btn {\n            text-transform: initial;\n        }\n\n        .policyBox .dropdown-menu {\n            max-height: 475px;\n            overflow-y: auto;\n        }\n\n        li.dropdown-item:last-of-type > a {\n            border: none;\n        }\n\n        .dropdown-toggle {\n            float: none;\n        }\n    "]
    })
], ItemSelectorComponent);
exports.ItemSelectorComponent = ItemSelectorComponent;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/item-selector/item-selector.component.js